import {Box, Chip, Typography} from '@mui/material';
import {useDispatch, useSelector} from 'react-redux';
import {Selector} from '../../state/selector';
import EditIcon from '@mui/icons-material/Edit';
import ReopenSelfAssessmentConfirmation from './ReopenSelfAssessmentConfirmation';
import Command from '../../state/actions/command';
import {useState} from 'react';
import LatestTestDate from '../Admin/AdminPage/LatestTestDate';

const styles = {
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 2,
    },
    statusChip: {
        marginLeft: 2,
    },
};

interface SelfAssessmentHeaderProps {
    title: string;
}

const SelfAssessmentHeader = (props: SelfAssessmentHeaderProps) => {
    const dispatch = useDispatch();
    const selfAssessmentLoaded = useSelector(Selector.SelfAssessment.loaded);
    const selfAssessmentId = useSelector(Selector.SelfAssessment.selfAssessmentId);
    const selfAssessmentSubmitted = useSelector(Selector.SelfAssessment.submitted);
    const isAdmin = useSelector(Selector.User.isAdmin);
    const viewingVersion = useSelector(Selector.QuestionList.viewingVersion);
    const companyId = useSelector(Selector.Company.selectedCompanyId);
    const companyStatusMap = useSelector(Selector.Company.companyStatusMap);
    const [reopenConfirmationOpen, setReopenConfirmationOpen] = useState<boolean>(false);

    const reopenSelfAssessment = () => {
        dispatch(Command.SelfAssessment.reopenSelfAssessment({}));
        setReopenConfirmationOpen(false);
    };

    return (
        <Box sx={styles.header}>
            <Typography variant={'h1'}>{props.title}</Typography>
            {(selfAssessmentLoaded && selfAssessmentId && selfAssessmentSubmitted) && (
                <Chip
                    label={'abgeschlossen'}
                    size={'small'}
                    color={'primary'}
                    sx={styles.statusChip}
                    onClick={isAdmin ? () => setReopenConfirmationOpen(true) : undefined}
                    icon={isAdmin ? <EditIcon /> : undefined}
                />
            )}
            {(isAdmin && selfAssessmentLoaded && selfAssessmentId && companyId) && (
                <>
                    <LatestTestDate
                        data={companyStatusMap[companyId]?.selfAssessment?.[viewingVersion]}
                        useStyle={true}
                    />
                </>
            )}
            <ReopenSelfAssessmentConfirmation
                open={reopenConfirmationOpen}
                onClose={() => setReopenConfirmationOpen(false)}
                onReopen={reopenSelfAssessment}
            />
        </Box>
    );
};

export default SelfAssessmentHeader;
